import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { API_URL_BASE } from '@/env';
import rules from '@/app/shared/domain/data/rules';
import AuthClientFactory from '@/app/shared/infrastructure/http/AuthClientFactory';
import roleRepository from '@/app/shared/infrastructure/persistence/role-repository';
import userRepository from '@/app/shared/infrastructure/persistence/user-repository';
import tokenRepository from '@/app/shared/infrastructure/persistence/token-repository';
import notificationRepository from '@/app/shared/infrastructure/persistence/notification-repository';
import AuthTemplate from '../templates/AuthTemplate.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const client = (new AuthClientFactory()).factory();
const valid = ref(false);
let loading = ref(false);

const email = ref('');
const pass = ref('');

const submit = () => {
    if (valid.value === true) {
        loading.value = true;

        client.post('/api/auth', {
            email: email.value,
            password: pass.value,
        }).then(response => {
            tokenRepository().set(response.data.token);
            roleRepository().insert(response.data.roles);

            const user = response.data.user;
            userRepository().insert({
                ...user,
                image: `${API_URL_BASE}/assets/images--collaborators--${user.image}/${response.data.token}`
            });
            window.location.href = '/';
        }).catch(error => {
            if (error.response?.status === 401) {
                notificationRepository().insert({
                    id: Date.now().toString(),
                    type: 'warning',
                    message: 'Usuário e/ou senha incorretos.',
                });
            } else if (error.response?.status === 500) {
                notificationRepository().insert({
                    id: Date.now().toString(),
                    type: 'error',
                    message: 'Desculpe, tivemos um erro interno. Tente mais tarde.',
                });
                console.error('auth error 500', error);
            } else {
                notificationRepository().insert({
                    id: Date.now().toString(),
                    type: 'error',
                    message: 'Desculpe, tivemos um erro inesperado. Tente mais tarde.',
                });
                console.error('auth error', error);
            }
        }).finally(() => loading.value = false);
    }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(AuthTemplate, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_form, {
        onSubmit: _withModifiers(submit, ["prevent"]),
        modelValue: valid.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((valid).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "my-4" }, {
                default: _withCtx(() => [
                  _createTextVNode("Bem vindo(a) ao Onino")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                class: "mb-3 centered-input",
                label: "E-mail",
                rules: [_unref(rules).required],
                modelValue: email.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
              }, null, 8, ["rules", "modelValue"]),
              _createVNode(_component_v_text_field, {
                label: "Senha",
                type: "password",
                required: "",
                modelValue: pass.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pass).value = $event)),
                rules: [_unref(rules).required]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_router_link, {
                to: "/redefinir-senha",
                class: "text-subtitle-1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Esqueci minha senha")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                loading: _unref(loading),
                type: "submit",
                color: "info",
                variant: "flat",
                size: "large",
                block: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Entrar")
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSubmit", "modelValue"])
    ]),
    _: 1
  }))
}
}

})